import { render, staticRenderFns } from "./AbkWebpagesTree.vue?vue&type=template&id=82e3a25a&scoped=true&"
import script from "./AbkWebpagesTree.vue?vue&type=script&lang=js&"
export * from "./AbkWebpagesTree.vue?vue&type=script&lang=js&"
import style0 from "./AbkWebpagesTree.vue?vue&type=style&index=0&id=82e3a25a&scoped=true&lang=scss&"
import style1 from "./AbkWebpagesTree.vue?vue&type=style&index=1&id=82e3a25a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e3a25a",
  null
  
)

export default component.exports